import React, { useEffect, useState } from "react";
import { Box, HorizontalStack, VerticalStack, Text, HorizontalGrid, Button } from "@shopify/polaris";
import { MoneyMinor, ExternalMinor } from "@shopify/polaris-icons";

import { typedFrontendVendorApi } from "@vendor-app/utils/typedFrontendVendorApi";

export const RevenueGenerated = () => {
  const [loading, setLoading] = useState(true);
  const [revenueGenerated, setRevenueGenerated] = useState({
    new_subscriptions: "--",
    subscription_revenue: "--",
    new_orders: "--",
    order_revenue: "--",
  });

  const getRevenueGeneratedData = async () => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      const response = await typedFrontendVendorApi.getReq("/relo-integration/attributed-revenue");
      if (response.type === "success") {setRevenueGenerated(response.body);}
    } catch (error) {
      console.error("Error fetching Relo revenue generated data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRevenueGeneratedData();
  }, []);

  const StatsContent = ({ value, label }) => {
    return (
      <Box>
        <VerticalStack gap="2" align="center" inlineAlign="center">
          <Text variant="heading2xl" as="p" fontWeight="medium" color={loading ? "subdued" : undefined}>
            {value}
          </Text>
          <Text variant="bodyMd" as="p" color="subdued" fontWeight="regular" truncate>
            {label}
          </Text>
        </VerticalStack>
      </Box>
    );
  };

  return (
    <React.Fragment>
      <div
        style={{
          borderRadius: "0.5rem",
          padding: "1.5rem",
          border: "1px solid #a7f3d0",
          background: "linear-gradient(to top, #eff6ff 0%, #ecfdf5 100%)",
        }}
      >
        <VerticalStack gap="6">
          <HorizontalStack gap="4" align="start" blockAlign="center">
            <div
              style={{
                background: "rgba(209, 255, 233, 1)",
                borderRadius: "100%",
                minWidth: "48px",
                minHeight: "48px",
              }}
            >
              <MoneyMinor
                width="24px"
                style={{ display: "block", fill: "rgba(5, 150, 105, 1)", margin: "12px auto" }}
              />
            </div>
            <VerticalStack gap="1" align="start">
              <Text variant="headingLg" fontWeight="semibold" as="p">
                Relo is generating additional revenue!
              </Text>
              <Text variant="bodyMd" fontWeight="regular" as="p" color="subdued">
                Performance over the last 30 days
              </Text>
            </VerticalStack>
          </HorizontalStack>

          <div style={{ borderRadius: "0.5rem", padding: "2rem", background: "rgba(255, 255, 255, 0.8)" }}>
            <HorizontalGrid
              columns={{ xs: 2, lg: 2, xl: 4 }}
              gap={{ xs: "800", lg: "800", xl: "0" }}
              alignItems="start"
            >
              <StatsContent value={revenueGenerated.order_revenue} label="Order revenue generated" />
              <StatsContent value={revenueGenerated.new_orders} label="New orders" />
              <StatsContent
                value={revenueGenerated.subscription_revenue}
                label="Subscription revenue generated"
              />
              <StatsContent value={revenueGenerated.new_subscriptions} label="New subscriptions" />
            </HorizontalGrid>
          </div>
        </VerticalStack>
      </div>

      <VerticalStack gap="2">
        <Text variant="headingMd" as="h6">
          Quick actions
        </Text>
        <HorizontalStack gap="2" align="start" blockAlign="center">
          <Button size="medium" icon={ExternalMinor} url="https://app.reloapp.co/" target="_blank" external>
            Go to Relo dashboard
          </Button>
          <Button
            size="medium"
            icon={ExternalMinor}
            url="https://app.reloapp.co/magic-cart"
            target="_blank"
            external
          >
            Customize Magic Cart
          </Button>
        </HorizontalStack>
      </VerticalStack>
    </React.Fragment>
  );
};
